import { createPortal } from "react-dom";
import type { ReactNode } from "react";
import { usePageHeaderRegistration, usePageTitleSlots } from "@/lib/page-title";

/**
 * Inyecta title/subtitle/eyebrow/actions en el header global de AppShell
 * vía Portales. No renderea nada inline — el shell se ocupa del layout.
 *
 * Si el shell todavía no montó los slots (primer paint), retornamos null
 * y la próxima render del shell lo coloca correctamente.
 */
export function PageHeader({
  title,
  subtitle,
  actions,
  eyebrow,
}: {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  eyebrow?: string;
}) {
  const { titleEl, actionsEl } = usePageTitleSlots();
  usePageHeaderRegistration();

  return (
    <>
      {titleEl &&
        createPortal(
          <div className="min-w-0 flex-1">
            {eyebrow && (
              <div className="text-[10px] font-semibold uppercase tracking-[0.18em] text-primary leading-none mb-0.5">
                {eyebrow}
              </div>
            )}
            <h1 className="font-display font-semibold text-base-content tracking-tight truncate text-base md:text-lg leading-tight">
              {title}
            </h1>
            {subtitle && (
              <div className="text-xs text-base-content/60 truncate hidden md:block leading-tight mt-0.5">
                {subtitle}
              </div>
            )}
          </div>,
          titleEl,
        )}
      {actions &&
        actionsEl &&
        createPortal(<div className="flex items-center gap-2 flex-wrap">{actions}</div>, actionsEl)}
    </>
  );
}
